export const EMAIL_CONFIRMED_EVENT = "EMAIL_CONFIRMED_EVENT";
